import lottie from "lottie-web";
import virusData from "../lottie/virus/data";
import whatsappData from "../lottie/whatsapp/data";
import yellowRectData from "../lottie/yellowrect/data.json";
import circleData from "../lottie/circle/data.json";
import medsData from "../lottie/meds/data";
import blueTriangleData from "../lottie/blue-triangle/data.json";
import blueCircleData from "../lottie/blue-circle/data.json";
import dashedLineData from "../lottie/dashed-line/data.json";
import horizontalLineData from "../lottie/horizontal-line/data.json";
import pizzaData from "../lottie/pizza/data.json";
import outlineCircleData from "../lottie/outline-circle/data.json";
import rotatingCircleData from "../lottie/rotating-circle/data.json";
import diagonalLineData from "../lottie/diagonal-line/data.json";
import doubleRectData from "../lottie/double-rect/data.json";
import yellowTriangleData from "../lottie/yellow-triangle/data.json";
import swipeData from "../lottie/swipe/data.json";
import scrollData from "../lottie/scroll/data.json";

const lottieWhatsapp = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="whatsapp"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: whatsappData,
});

const lottieVirus = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="virus"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: virusData,
});

const yellowRect = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="yellowrect"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: yellowRectData,
});

const circle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="circle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: circleData,
});

const meds = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="meds"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: medsData,
});

const blueTriangle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="blue-triangle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: blueTriangleData,
});

const blueCircle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="blue-circle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: blueCircleData,
});

const dashedLine = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="dashed-line"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: dashedLineData,
});

const horintalLine = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="horizontal-line"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: horizontalLineData,
});

const pizza = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="pizza"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: pizzaData,
});

const outlineCircle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="outline-circle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: outlineCircleData,
});

const rotatingCircle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="rotating-circle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: rotatingCircleData,
});

const diagonalLine = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="diagonal-line"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: diagonalLineData,
});

const doubleRect = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="double-rect"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: doubleRectData,
});

const yellowTriangle = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="yellow-triangle"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: yellowTriangleData,
});

const swipe = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="swipe"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: swipeData,
});

const scroll = lottie.loadAnimation({
    container: document.querySelector('.lottie[data-anim="scroll"]'),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: scrollData,
});

export { lottieWhatsapp, lottieVirus };
